import mixpanel from 'mixpanel-browser';
import { HelmetProvider, Helmet } from 'react-helmet-async';
import { forwardRef, ReactNode, useEffect } from 'react';
import { useLocation } from 'react-router';

import { Box, BoxProps, Container } from '@mui/material';
import useAuth from 'src/hooks/useAuth';
import useMerchant from 'src/hooks/useMerchant';
import usePage from 'src/hooks/usePage';
import { StackColumn, StackRow, StackRowForm } from './stack-column';
import { AppTypography } from './app-typography';

// ----------------------------------------------------------------------

interface Props extends BoxProps {
  children: ReactNode;
  meta?: ReactNode;
  title: string;
  titleActions?: JSX.Element;
  actions?: JSX.Element;
}
const Page = forwardRef<HTMLDivElement, Props>(({ children, title = '', meta, actions, titleActions, ...other }, ref) => {
  const { user } = useAuth();
  const { merchant } = useMerchant();
  const { setPageTitle } = usePage();

  const location = useLocation();
  // const mdUp = useResponsive('up', 'md');

  useEffect(() => {
    if (title) {
      setPageTitle(title);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [title]);

  useEffect(() => {
    if (user?.email && merchant?.code) {
      mixpanel.track(`View: ${title}`, {
        title: `${title}`,
        url: window.location.href
      });
    }
  }, [title, user?.email, merchant?.code]);

  const isErrorPage = /^\d+$/.test((location.pathname ?? '').split('/').pop() ?? '');

  //
  //

  return <HelmetProvider>
    <Helmet>
      <title>{`${title && `${title} |`} CarbonClick`}</title>
      {meta}
    </Helmet>

    <Container maxWidth="lg" sx={{ mt: 2, display: 'flex', flex: 1 }}>
      <StackColumn gap={1.5} mt={2}>

    {title && !isErrorPage &&
        <StackRowForm justifyContent={{ xs: 'flex-start', sm: "space-between" }}>
          <StackRow alignItems="center" minHeight={47}>
            <AppTypography variant="title1">{title}</AppTypography>
            {titleActions && <Box>{titleActions}</Box>}
          </StackRow>
          <StackRow flexWrap="wrap" justifyContent="flex-end">
            {actions && <Box>{actions}</Box>}
          </StackRow>
        </StackRowForm>
    }

    <Box ref={ref} {...other} display='flex' flexDirection='column' flex={1}>
      {children}
    </Box>

    </StackColumn>
    </Container>

  </HelmetProvider>
});

export default Page;
